import React, { useState } from "react";
import Layout from "../layouts/Layout";
import CompetitionHero from "../components/competitions/Hero";
import CompetitionsList from "../components/competitions/CompetitionsList";

const Competitions = () => {
  const [activeTab, setActiveTab] = useState("practices");

  return (
    <Layout>
      <CompetitionHero />
      <CompetitionsList activeTab={activeTab} setActiveTab={setActiveTab} />
    </Layout>
  );
};

export default Competitions;
